import React from "react";
import Loadable from "react-loadable";
import { Loading } from "components";

const MyLoadingComponent = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return <Loading />;
  }
  // Handle the error state
  else if (error) {
    return (
      <div>متاسفانه در نمایش این صفحه مشکلی بوجود آمده است .منتظر بمانید.</div>
    );
  } else {
    return null;
  }
};

export default [
  [
    {
      component: Loadable({
        loader: () => import("./views/SignIn"),
        loading: MyLoadingComponent
      }),
      link: "/",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/Reset"),
        loading: MyLoadingComponent
      }),
      link: "/reset",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/Verify"),
        loading: MyLoadingComponent
      }),
      link: "/reset/verify/:token",
      public: true
    }
  ],
  [
    {
      component: Loadable({
        loader: () => import("./views/security"),
        loading: MyLoadingComponent
      }),
      link: "/security",
      public: false,
      name: "038"
    },
    {
      component: Loadable({
        loader: () => import("./views/KYCConfirmation"),
        loading: MyLoadingComponent
      }),
      link: "/KYCConfirmation",
      public: false,
      name: "281"
    },
    {
      component: Loadable({
        loader: () => import("./views/PaymentDetailsConfirmation"),
        loading: MyLoadingComponent
      }),
      link: "/PaymentDetailsConfirmation",
      public: false,
      name: "282"
    },
    {
      component: Loadable({
        loader: () => import("./views/DirectReferral"),
        loading: MyLoadingComponent
      }),
      link: "/DirectReferral",
      public: false,
      name: "046"
    },
    {
      component: Loadable({
        loader: () => import("./views/MessageConfig"),
        loading: MyLoadingComponent
      }),
      link: "/Setting/MessageConfiguration",
      public: false,
      name: "445"
    },
    {
      component: Loadable({
        loader: () => import("./views/Staff"),
        loading: MyLoadingComponent
      }),
      link: "/StaffList",
      public: false,
      name: "443"
    },
    {
      component: Loadable({
        loader: () => import("./views/RoleList"),
        loading: MyLoadingComponent
      }),
      link: "/RoleList",
      public: false,
      name: "449"
    },
    {
      component: Loadable({
        loader: () => import("./views/Dashboard"),
        loading: MyLoadingComponent
      }),
      link: "/dashboard",
      public: false,
      name: "016"
    },
    {
      component: Loadable({
        loader: () => import("./views/EventManagement"),
        loading: MyLoadingComponent
      }),
      link: "/EventManagement",
      public: false,
      name: "293"
    },
    {
      component: Loadable({
        loader: () => import("./views/NetworkSetting"),
        loading: MyLoadingComponent
      }),
      link: "/Setting/NetworkSetting",
      public: false,
      name: "270"
    },
    {
      component: Loadable({
        loader: () => import("./views/ProductManagement"),
        loading: MyLoadingComponent
      }),
      link: "/ProductManagement",
      public: false,
      name: "273"
    },
    {
      component: Loadable({
        loader: () => import("./views/UploadManagement"),
        loading: MyLoadingComponent
      }),
      link: "/UploadManagement",
      public: false,
      name: "292"
    },
    {
      component: Loadable({
        loader: () => import("./views/MemberList"),
        loading: MyLoadingComponent
      }),
      link: "/AllMembers",
      public: false,
      name: "275"
    },
    {
      component: Loadable({
        loader: () => import("./views/BlockList"),
        loading: MyLoadingComponent
      }),
      link: "/BlockedMembers",
      public: false,
      name: "276"
    },
    {
      component: Loadable({
        loader: () => import("./views/CommercialRepresentative"),
        loading: MyLoadingComponent
      }),
      link: "/Commerciallist",
      public: false,
      name: "528"
    },
    {
      component: Loadable({
        loader: () => import("./views/InstallmentList"),
        loading: MyLoadingComponent
      }),
      link: "/InstallmentPremittedList",
      public: false,
      name: "529"
    },
    {
      component: Loadable({
        loader: () => import("./views/PaymentMethods"),
        loading: MyLoadingComponent
      }),
      link: "/PaymentMethods",
      public: false,
      name: "271"
    },
    {
      component: Loadable({
        loader: () => import("./views/BWalletSummery"),
        loading: MyLoadingComponent
      }),
      link: "/BWalletSummery",
      public: false,
      name: "288"
    },
    {
      component: Loadable({
        loader: () => import("./views/TransactionHistory"),
        loading: MyLoadingComponent
      }),
      link: "/TransactionHistory",
      public: false,
      name: "289"
    },
    {
      component: Loadable({
        loader: () => import("./views/WithdrawFund"),
        loading: MyLoadingComponent
      }),
      link: "/WithdrawFund",
      public: false,
      name: "290"
    },
    {
      component: Loadable({
        loader: () => import("./views/TransferFund"),
        loading: MyLoadingComponent
      }),
      link: "/TransferFund",
      public: false,
      name: "291"
    },
    {
      component: Loadable({
        loader: () => import("./views/IncomesAndPaidBonus/Incomes"),
        loading: MyLoadingComponent
      }),
      link: "/Incomes",
      public: false,
      name: "452"
    },
    {
      component: Loadable({
        loader: () => import("./views/IncomesAndPaidBonus/PaidBonus"),
        loading: MyLoadingComponent
      }),
      link: "/PaidBonus",
      public: false,
      name: "453"
    },
    {
      component: Loadable({
        loader: () => import("./views/SignUp"),
        loading: MyLoadingComponent
      }),
      link: "/sign-up",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/NotFound"),
        loading: MyLoadingComponent
      }),
      link: "/not-found",
      public: true,
      name: "Not Found"
    }
  ]
];
